import { render, staticRenderFns } from "./Access_Request.vue?vue&type=template&id=19898465&"
import script from "./Access_Request.vue?vue&type=script&lang=js&"
export * from "./Access_Request.vue?vue&type=script&lang=js&"
import style0 from "./Access_Request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports